export const LETTERS = '/letters'
// export const INCOMING = '/letters-incoming'
export const EXTERNAL_LETTERS = '/external-letters'
// export const LETTER_PUBLIC_INFO = '/public/outgoing_letter'
